import { useCallback } from "react";
import { getSeenVersions, isVersionAlreadySeen, saveVersionAsSeen } from "../utils/versionSeen";

export function useSeenVersion({ userId, frontendVersion, backendVersion }) {
    const storageKey = `app/user/${userId}/update/seen`;
    const checkSeen = useCallback(() => {
        const seen = getSeenVersions(storageKey);

        return isVersionAlreadySeen(seen, frontendVersion, backendVersion);
    }, [frontendVersion, backendVersion, storageKey]);

    const markAsSeen = useCallback(() => {
        saveVersionAsSeen(storageKey, frontendVersion, backendVersion);

    }, [storageKey, frontendVersion, backendVersion]);

    return {
        isVersionAlreadySeen: checkSeen,
        saveVersionAsSeen: markAsSeen,
    }
};